import React, { FC } from "react";
import ReactCountryFlag from "react-country-flag";

interface GuestNameWithFlagProps {
  name?: string;
  countryCode?: string;
  className?: string;
}

export const GuestNameWithFlag: FC<GuestNameWithFlagProps> = ({
  name,
  countryCode,
  className = "",
}) => {
  return (
    <div className={`flex justify-center items-center gap-2 ${className}`}>
      {countryCode && (
        <ReactCountryFlag
          countryCode={countryCode}
          svg
          className={"!h-8 !w-6"}
        />
      )}
      {!!name && <span>{name}</span>}
    </div>
  );
};
